import { Component } from '@angular/core';

@Component({
  selector: 'app-payment-overdue',
  standalone: true,
  imports: [],
  templateUrl: './payment-overdue.component.html',
  styleUrl: './payment-overdue.component.scss'
})
export class PaymentOverdueComponent {

}
